import React from 'react'

import './image-hover-interaction.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children: React.ReactNode
    hoverContent: React.ReactNode
  }
>

const ImageHoverInteraction = ({className, children, hoverContent, ...props}: Props) => (
  <div {...props} className={cn('ImageHoverInteraction', {}, className)}>
    {children}
    <div className="ImageHoverInteraction__hoverContent">{hoverContent}</div>
  </div>
)

export default ImageHoverInteraction
